
import React from "react";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from "@mui/icons-material/Email";
// import FacebookIcon from "@mui/icons-material/Facebook";
import FacebookIcon from "../../images/facebook-svgrepo-com.svg";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';

function Contactinfo() {
  const contactItems = [
   
    {
      icon: <WhatsAppIcon sx={{ color: "#252525", fontSize:"25px", }} />,
      title: "Contact",
      value: "918735830332",
    },
    {
      icon: <EmailIcon sx={{ color: "#252525", fontSize:"25px" }} />,
      title: "Email",
      value: "support@desihisab.com",
    },
  ];
  const socialLinks = [
  { icon: FacebookIcon, link: "https://www.facebook.com/desihisaab" },
  { icon: XIcon, link: "https://x.com/desihisaab" },
  { icon: InstagramIcon, link: "https://www.instagram.com/desihisaab/" },
  { icon: YouTubeIcon, link: "https://www.youtube.com/@DesiHisaab" },

];
  return (
      <Box sx={{ px: 3, py: 0 }}>
        <h2 style={{marginBottom: "10px" }}>
          Contact Us
        </h2>
        <Typography style={{marginBottom: "20px" }}>
          This is your gateway to connect with us directly. Whether you have feedback
        </Typography>
      <Stack spacing={3}>
        {contactItems.map((item, index) => (
          <Stack key={index} direction="row" spacing={2} alignItems="flex-start">
            <Box
              sx={{
                p: 1.5,
                borderRadius: 50,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 50,
                minHeight: 50,
                backgroundColor: "#fdd26b"
              }}
            >
              {item.icon}
            </Box>
            <Box>
              <Typography fontWeight="600" fontSize="18px" sx={{ fontFamily: "Montserrat"}} >
                {item.title}
              </Typography>
              <Typography
  variant="body2"
  sx={{ color: "#555", fontSize: "16px", fontFamily: "Montserrat" , textDecoration:"none"}}
  component="a"
  href={
    item.title === "Email"
      ? `mailto:${item.value}`
      : item.title === "Contact"
      ?`https://wa.me/${item.value.replace(/[^0-9]/g, "")}?text=${encodeURIComponent("Hi")}`
 // WhatsApp link
      : "#"
  }
  target="_blank"
  rel="noopener noreferrer"
>
  {item.value}
</Typography>
            </Box>
          </Stack>
        ))}
      </Stack>

      {/* Social Icons */}
      <Box mt={6}>
        <Stack direction="row" spacing={2}>
 {socialLinks.map((item, index) => (
  <IconButton
    key={index}
    sx={{
      backgroundColor: "#f3f3f3",
      "&:hover": { backgroundColor: "#fdd26b" },
      width: 40,
      height: 40,
    }}
    onClick={() => window.open(item.link, "_blank")}
  >
    {index === 0 ? (
      <img src={item.icon} alt="Facebook" style={{ width: 25, height: 25 }} />
    ) : (
      <item.icon fontSize="small" sx={{ color: "#333" }} />
    )}
  </IconButton>
))}
</Stack>

      </Box>
    </Box>
  )
}

export default Contactinfo
